import { render, staticRenderFns } from "./historyRecord.vue?vue&type=template&id=ef54f128&scoped=true&"
import script from "./historyRecord.vue?vue&type=script&lang=js&"
export * from "./historyRecord.vue?vue&type=script&lang=js&"
import style0 from "./historyRecord.vue?vue&type=style&index=0&id=ef54f128&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef54f128",
  null
  
)

export default component.exports